import type { AuthMode } from "@/types/mandate-form";

export interface MandateForm {
  // Step 1 — Customer
  customerName: string;
  customerMobile: string;
  customerEmail: string;
  dob: string;
  customerPan: string;
  aadhaar: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  // Step 2 — Product
  category: string;
  brand: string;
  model: string;
  serialNo: string;
  invoiceNo: string;
  invoiceDate: string;
  description: string;
  // Step 3 — EMI & Mandate
  productPrice: string;
  downPayment: string;
  interestRate: string;
  tenure: string;
  authMode: AuthMode | "";
  upiId: string;
  amount: string;
  maxAmount: string;
  frequency: string;
  startDate: string;
  endDate: string;
  purpose: string;
  remarks: string;
  // Step 4 — Bank
  bankName: string;
  accountType: "Savings" | "Current";
  accountNumber: string;
  confirmAccountNumber: string;
  ifsc: string;
  // Step 5 — Verification
  idProofType: string;
  idProofFileName: string;
  idProofUrl: string;
  addressProofType: string;
  addressProofFileName: string;
  addressProofUrl: string;
  customerPhoto: string;
  signature: string;
  // Step 6 — Review
  mpin: string;
}

export type FormErrors = Partial<Record<keyof MandateForm, string>>;

export type SetField = (key: keyof MandateForm, value: string) => void;

export const emptyForm: MandateForm = {
  customerName: "",
  customerMobile: "",
  customerEmail: "",
  dob: "",
  customerPan: "",
  aadhaar: "",
  address: "",
  city: "",
  state: "",
  pincode: "",
  category: "",
  brand: "",
  model: "",
  serialNo: "",
  invoiceNo: "",
  invoiceDate: "",
  description: "",
  productPrice: "",
  downPayment: "",
  interestRate: "",
  tenure: "",
  authMode: "",
  upiId: "",
  amount: "",
  maxAmount: "",
  frequency: "",
  startDate: "",
  endDate: "",
  purpose: "",
  remarks: "",
  bankName: "",
  accountType: "Savings",
  accountNumber: "",
  confirmAccountNumber: "",
  ifsc: "",
  idProofType: "",
  idProofFileName: "",
  idProofUrl: "",
  addressProofType: "",
  addressProofFileName: "",
  addressProofUrl: "",
  customerPhoto: "",
  signature: "",
  mpin: "",
};

export const BASE_STEPS = [
  "Customer Details",
  "Product Details",
  "EMI & Mandate",
  "Verification",
  "Review & Submit",
];

// The Bank Details step is only required for eNACH. UPI Autopay drops it,
// so the stepper shrinks from 6 to 5 steps and renumbers the rest.
export function getSteps(authMode: string): string[] {
  if (authMode === "UPI_AUTO_PAY") return BASE_STEPS;
  return [
    "Customer Details",
    "Product Details",
    "EMI & Mandate",
    "Bank Details",
    "Verification",
    "Review & Submit",
  ];
}